/**
 * Autocomplete overrides — same panel language as CoordioDropdown / updated Select.
 */

import type { Theme } from '@mui/material/styles';

const autocomplete: Theme['components'] = {
  MuiAutocomplete: {
    styleOverrides: {
      paper: {
        marginTop: '4px',
        minWidth: 280,
        maxWidth: 'min(96vw, 420px)',
        borderRadius: '8px',
        border: '1px solid var(--color-border-default)',
        backgroundColor: 'var(--color-bg-surface)',
        backgroundImage: 'none',
        boxShadow: 'var(--shadow-lg, 0 8px 24px rgba(0, 0, 0, 0.12))',
      },
      listbox: {
        padding: '4px',
        maxHeight: 'min(40vh, 280px)',
      },
      option: {
        padding: '7px 8px',
        borderRadius: '4px',
        fontSize: '0.8125rem',
        lineHeight: 1.35,
        whiteSpace: 'normal',
        '&[aria-selected="true"]': {
          backgroundColor: 'var(--color-accent-subtle)',
          color: 'var(--color-text-primary)',
          fontWeight: 500,
        },
        '&.Mui-focused, &[data-focus="true"]': {
          backgroundColor: 'var(--color-bg-inset)',
        },
      },
      inputRoot: {
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
          borderColor: 'var(--color-accent-primary)',
        },
      },
    },
  },
};

export default autocomplete;
